<template>
  <el-container>
    <div class="app-container">
      <div class="headBar-block">
        <HeadBar/>
      </div>
      <div class="operation-block">
        <div class="operation-block-ui">
          <router-view />
        </div>
      </div>
      <div class="footer-block">
        <Footer />
      </div>
    </div>
  </el-container>
</template>

<script>
import { HeadBar, SlideBar,Footer, AppMain } from "./components";
export default {
  components: { HeadBar, SlideBar, Footer,AppMain },
  data() {
    return {};
  },

  methods: {},
};
</script>

<style scoped>
.headBar-block{
  width: 100%;
  position: fixed;
  top: 0;
  background-color: #FFF;
  border-bottom: 1px solid #eeeeee;
  min-width: 1366px;
  z-index: 1000;
}
.operation-block-ui{
  width: 100%;
  min-width: 1366px;
  margin-top: 126px;
}
.app-container{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.operation-block{
  /* margin-top: 126px; */
  /* background-color: #fbfbfb; */
  min-height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.footer-block{
  width: 100%;
  /* position: fixed;
  bottom: 0px; */
  margin-top: 20px;
  min-width: 1366px;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/layout.vue